import { Injectable } from '@angular/core';

// Libraries
import _clone from 'lodash-es/clone';
import _lowerCase from 'lodash-es/lowerCase';
import _groupBy from 'lodash-es/groupBy';
import _map from 'lodash-es/map';
import _reduce from 'lodash-es/reduce';
import _mapKeys from 'lodash-es/mapKeys';

// Afidium
import { Yii } from "libraries/interfaces/Yii";
import { IElement, IQuantity } from './IPrice-datatable';
import { IQuote } from 'libraries/service/resources/airTrip/IGetAirTripQuotes';
import { IPrice, IPriceDetail, IXId } from 'libraries/service/resources/booking/interfaces/IGetBookings';

@Injectable()
export class DatatablePriceService {

    public set dataSource(dataTableValues) {
        this._dataSource = dataTableValues;
    }

    public get dataSource() {
        return this._dataSource;
    }

    public get displayedColumns() {
        return this._displayedColumns;
    }

    public set displayedColumns(columns) {
        this._displayedColumns = columns;
    }

    public get quantity() {
        return this._quantity;
    }

    public set quantity(quantities) {
        this._quantity = quantities;
    }
    private static readonly VALID_TOTAL_TYPES = ['Base', 'Tax', 'Total', 'Fee'];
    public labels = {
        total: Yii.t('wui-shared-js', 'Total'),
        base: Yii.t('wui-shared-js', 'HT'),
        tax: Yii.t('wui-shared-js', 'Taxes'),
        fee: Yii.t('wui-shared-js', 'Frais'),
        adult: Yii.t('wui-shared-js', 'Total Adulte'),
        infant: Yii.t('wui-shared-js', 'Total Bébé'),
        child: Yii.t('wui-shared-js', 'Total Enfant'),
    };

    private _dataSource: IElement[];
    private _displayedColumns: string[];
    private _quantity: IQuantity;

    public getHeaderTranslation(value: string) {
        return this.labels[value];
    }


    public getQuantities(bookingItem: IQuote): IQuantity {
        const idsByType: { [type: string]: Set<string> } = bookingItem.price
            .reduce((acc: { [type: string]: Set<string> }, price: IPrice): { [type: string]: Set<string> } =>
                {
                price.detail.base.forEach((baseItem: IPriceDetail) => {
                    baseItem.traveller.forEach((travellerItem: IXId) => {
                        acc[_lowerCase(baseItem.xUnitType)].add(travellerItem.xId);
                    });
                });
                return acc;
            }, { adult: new Set<string>(), child: new Set<string>(), infant: new Set<string>() });

        return {
            adult: idsByType.adult.size,
            child: idsByType.child.size,
            infant: idsByType.infant.size,
        };
    }
}
